import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import { Link } from 'react-router-dom'
import styles from './careerContentDetailComponent.scss'
import CareerContentCard from '../careerContentCard/careerContentCardComponent'
import ContentContainer from '../contentContainer/contentContainerComponent'
import GradientHr from '../gradientHr/gradientHrComponent'
import IntroText from '../introText/introTextComponent'
import DarkContentSection from '../../components/darkContentSection/darkContentSectionComponent'
import PropTypes from 'prop-types'
export function CareerContentDetail (props: Props) {
  const { t } = props
  return (
    <div>
      <ContentContainer>
        <IntroText
          title={props.endorsement + ' ' + t('career:careers')}
          icon={props.icon}
          description={props.description}
        >
          <p>
            {t('career:careersDesc1')}{' '}
            <Link to={props.endorsementRoute}>{props.endorsement}</Link>{' '}
            {t('career:careersDesc2')}
          </p>

          {props.secondDescription &&
            <p>
              {props.secondDescription}
            </p>}
        </IntroText>
      </ContentContainer>
      <hr className={styles.spaceBottom} />
      <ContentContainer>
        <div className={styles.row}>
          {props.careers.map((career, index) =>
            <CareerContentCard
              key={index}
              title={career.title}
              description={career.description}
              salaryRange={career.salaryRange}
              demand={career.demand}
              mobility={career.mobility}
              educationReqs={career.educationReqs}
            />
          )}
        </div>
      </ContentContainer>
      <hr className={styles.spaceBottom} />
      <ContentContainer>
        <div className={styles.row}>
          <section className={styles.twoThirds}>
            <h2>
              {t('career:findoutwhatyouneed')}
            </h2>
            <GradientHr />
            <div className={styles.row}>
              <div className={styles.oneThird}>
                <h3>
                  {t('career:demand')}
                </h3>
                <p>
                  {t('career:demandDesc')}
                </p>
              </div>
              <div className={styles.oneThird}>
                <h3>
                  {t('career:salary')}
                </h3>
                <p>
                  {t('career:salaryDesc')}
                </p>
              </div>
              <div className={styles.oneThird}>
                <h3>
                  {t('career:mobility')}
                </h3>
                <p>
                  {t('career:mobilityDesc')}
                </p>
              </div>
            </div>
            <div>
              <h3>
                {t('career:educationReqs')}
              </h3>
              <p>
                {t('career:educationDesc')}
              </p>
            </div>
          </section>
          <section className={styles.oneThird}>
            <h2>
              {t('career:sources')}
            </h2>
            <GradientHr />
            <ul>
              <li>
                <a
                  href='https://texascareercheck.com/ExploreCareer/OccupationInfo'
                  target='_blank'
                >
                  {t('career:twcip')}
                </a>
              </li>
              <li>
                <a
                  href='https://money.usnews.com/careers/best-jobs/rankings'
                  target='_blank'
                >
                  {t('career:usnwr')}
                </a>
              </li>
            </ul>

            <p>
              {t('career:disclaimer')}
            </p>
          </section>
        </div>
      </ContentContainer>
      <DarkContentSection className={styles.lightBorderBottom}>
        <IntroText title={t('career:mgCallout')} headerElement='h2'>
          <a
            href='https://www.middlegalaxy.org/'
            target='_blank'
            className={styles.buttonLink}
          >
            {t('career:middleGalaxy')}
          </a>
        </IntroText>
      </DarkContentSection>
    </div>
  )
}
CareerContentDetail.propTypes = {
  t: PropTypes.func.isRequired,
  icon: PropTypes.element,
  endorsement: PropTypes.string.isRequired,
  endorsementRoute: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  secondDescription: PropTypes.string,
  careers: PropTypes.arrayOf(
    PropTypes.shape({
      pathway: PropTypes.string,
      description: PropTypes.string,
      salaryRange: PropTypes.string,
      demand: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
      mobility: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
      educationReqs: PropTypes.oneOf([
        'highschool',
        'associates',
        'bachelors',
        'law',
        'masters'
      ])
    })
  ).isRequired
}

export default compose(pure, translate())(CareerContentDetail)



// WEBPACK FOOTER //
// ./src/components/careerContentDetail/careerContentDetailComponent.js